import planManager from '@devstark/spreadsimple-plan-manager'
const featureRestrictions = planManager.featureRestrictions
export function allowFeature(featureName, { user, website }) {
  return featureRestrictions[featureName].allowed({
    user,
    website
  })
}
